// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

import jQuery from 'jquery';
$ = jQuery;

// fontawesome
import '@fortawesome/fontawesome-pro';
import '../stylesheets/fontawesome';

// jquery-ui
import 'jquery-ui/ui/widgets/sortable';

// js-cookie
import Cookies from 'js-cookie'
global.Cookies = Cookies;

// bootstrap 5.0
import './frontend/bootstrap.min';
import '../stylesheets/frontend/bootstrap.min';

// select2
import 'select2';
import 'select2/dist/css/select2.css';
// import 'select2-bootstrap4-theme/dist/select2-bootstrap4.css';

import 'jquery-mask-plugin';
import 'jquery-match-height';

// scroll & effect
import 'wowjs/css/libs/animate';
import {WOW} from 'wowjs'
global.WOW = WOW;

// js
import './frontend/account';
import './frontend/banner_ad_applications';
import './frontend/companies';
import './frontend/jccg_event_entries';
import './frontend/members';
import './frontend/registrations';

// stylesheets
import '../stylesheets/application';

//#####################################################################################################
//# COMMON FUNCTIONS
//#####################################################################################################

(function($) {
  "use strict";
  $(document).ready(function() {init();});

  const init = function() {
    reset_maskable_phones();

    $('.select2able-multiple').select2({
      multiple: true,
    });
  }

})(jQuery);

window.reset_maskable_phones = function() {
  $('.maskable-phone').unmask().mask('(000) 000-0000');
}

var wow = new WOW({
  animateClass: 'animated',
  //offset:       50,
  mobile:       false
  //callback:     function (box) {
  //  console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  //}
});
wow.init();

// Scroll to Top
$(function(){
  "use strict";
  var scrollLink = ( '#page-top a' );
  $( scrollLink ).click( function () {
    var speed = 500;
    var href = $( this ).attr( "href" );
    var target = $( href == "#" || href == "" ? 'html' : href );
    var position = target.offset().top;
    $( "html, body" ).animate( {
      scrollTop: position
    }, speed, "swing" );
    return false;
  });
  var topBtn = $( '#page-top' );
  topBtn.hide();
  $( window ).scroll( function () {
    if ( $( this ).scrollTop() > 460 ) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });
});

//Page Title Display to Title Tag	
$(function(){
  "use strict";
  var pageTitle = $('li.breadcrumb-item.active').html();
  var pageCate = $('li.breadcrumb-item[aria-current="page"] a').html();
  //console.log(pageTitle + ' | ' + pageCate);
    if ( pageTitle != undefined && pageCate != undefined ) {
      $('title').prepend(pageTitle + ' | ' + pageCate + ' | ');
    } else if ( pageTitle != undefined || pageCate != undefined ) {
      $('title').prepend(pageTitle + ' | ');
    };
  });